import { validFor } from '@/theme/validFor'
import React, { FC } from 'react'
import { SectionSeparator } from '@/components/atoms/separator'
import { Capitalized } from '@/components/atoms/typography'
import styled, { css } from 'styled-components'
import { textAlign, padding } from 'styled-system'

const Bordered = css`
  ${(props) =>
    !props.customLayout
      ? `border: 1px solid ${props.theme.colors.sectionSeparator};`
      : ''}
  ${validFor.mobile`
      ${(props) =>
        !props.customLayout
          ? `background-color: ${props.theme.colors.background};`
          : ''}
  `}
`

export const Head = styled.thead`
  ${Bordered}
`

export const Body = styled.tbody`
  ${Bordered}
  & tr:last-child {
    display: none;
  }
`

export const HeadRow: FC = ({ children }) => <tr>{children}</tr>

export const BodyRow: FC = ({ children, ...rest }) => (
  <>
    <tr {...rest}>{children}</tr>
    <tr>
      <td colSpan={React.Children.toArray(children).length}>
        <SectionSeparator />
      </td>
    </tr>
  </>
)

type CellProps = {
  textAlign?: string
} & Rest

export const BodyCell: FC<CellProps> = ({
  textAlign = 'left',
  children,
  ...rest
}) => (
  <Td textAlign={textAlign} {...rest}>
    {children}
  </Td>
)

export const HeadCell: FC<CellProps> = ({
  textAlign = 'left',
  children,
  ...rest
}) => (
  <Th textAlign={textAlign} {...rest}>
    <ThText>{children}</ThText>
  </Th>
)

const Th = styled.th`
  padding: 0;
  ${textAlign};
`

const Td = styled.td`
  padding-top: 20px;
  padding-bottom: 20px;
  ${validFor.mobile`
    padding-top: 15px;
    padding-bottom: 15px;
  `}
  ${textAlign};
  &&& {
    ${padding};
  }
`

const ThText = styled(Capitalized)`
  text-transform: uppercase;
  opacity: 0.6;
`
